import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DivisionQueryVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String']['input'];
}>;

export type DivisionQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<
    { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'parentAccountId' | 'tradingName' | 'type'>
  >;
  legacyAccount?: GraphQLTypes.Maybe<
    { __typename?: 'LegacyAccount' } & Pick<GraphQLTypes.LegacyAccount, 'name'> & {
        division?: GraphQLTypes.Maybe<{ __typename?: 'Division' } & Pick<GraphQLTypes.Division, 'name' | 'parentAccountId'>>;
      }
  >;
};

export const DivisionDocument = gql`
  query division($id: String!) {
    account(accountId: $id) {
      parentAccountId
      tradingName
      type
    }
    legacyAccount(uuid: $id) {
      division {
        name
        parentAccountId
      }
      name
    }
  }
`;
